module.exports = __webpack_public_path__ + "b8124e5d1e5353e4d7f98406f03f5288.jpg";